import { useAuth } from '../../context/AuthContext';
import PatientAppointmentTable from "./PatientAppointmentTable";
import ProviderAppointmentTable from "./ProviderAppointmentTable";

interface FilterState {
  dateRange: string;
  timeSlot: string;
  status: string;
  visitType: string;
  visitReason: string;
}

interface AppointmentTableProps {
  from?: "upcoming" | "past";
  currentUser?: string;
  filters?: FilterState;
}

export default function AppointmentTable({ from, currentUser, filters }: AppointmentTableProps) {
  const { user } = useAuth();

  // Render different table based on user role
  if (user?.role === 'patient') {
    return <PatientAppointmentTable from={from} currentUser={currentUser} filters={filters} />;
  }

  // Default to provider table
  return <ProviderAppointmentTable from={from} currentUser={currentUser} filters={filters} />;
}
